define(
    'views/news-listing-view',[
        'jquery',
        'rivets',

        'utils/view',

        'modules/newscollection'
    ],

    function ($, rivets, View, NewsCollection) {

        var NewsCollectionView = (function() {

            function NewsCollectionView () {}

            NewsCollectionView.prototype.initNewsCollection = function () {
                var newsCollection = new NewsCollection();

                newsCollection.setNumberToLoad(5);

                rivets.bind($('#newslistId'), {
                    news: newsCollection.news,
                    loadAdditional: function () {
                        newsCollection.loadAdditional();
                    },
                    listLoaded: newsCollection.listLoaded,
                    syncing: newsCollection.syncing,
                    syncing2: newsCollection.syncing2,
                    moreNewsAvailable: newsCollection.moreNewsAvailable
                });
            };

            return NewsCollectionView;
        })();

        return View('NewsCollectionView', function () {
            var mpv = new NewsCollectionView();
            mpv.initNewsCollection();
        });
    }
);
